export default "__VITE_ASSET__d2052eac__"